import { render } from "./LogoIcon.vue?vue&type=template&id=93f5c4e0&scoped=true&ts=true"
import script from "./LogoIcon.vue?vue&type=script&lang=ts"
export * from "./LogoIcon.vue?vue&type=script&lang=ts"

import "./LogoIcon.vue?vue&type=style&index=0&id=93f5c4e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93f5c4e0"]])

export default __exports__